import "../css/main.css";
import "./gsap-animations";
(function ($) {
  // $( '.submit--call-me' ).on( 'click', function() {
  //         var transactionId = decodeURIComponent((new RegExp('[?|&]' + 'transaction_id' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
  //         var script = document.createElement('script');
  //         script.src = 'https://partners.equitrk.com.au/aff_lsr?offer_id=412&transaction_id=' + transactionId;
  //         document.getElementsByTagName('head')[0].appendChild(script);
  // } );

  // reference: https://contactform7.com/tracking-form-submissions-with-google-analytics/
  // Get ID; ID from "Beat the price - Plan A"
  // var form_145_id = $('#wpcf7-f145-p140-o1');

  // if( form_145_id ) {
  //     document.addEventListener( 'wpcf7mailsent', function( event ) {
  //         ga('send', 'event', { eventCategory: 'beat your bill', eventAction: 'submit', eventLabel: 'call me', eventValue: 10})
  //     }, false );
  // }

  // var form_178_id = $('#wpcf7-f178-p174-o1');

  // if( form_178_id ) {

  //     function ga_178() {
  //         ga('send', 'event', { eventCategory: 'beat your bill', eventAction: 'click', eventLabel: 'qoute me', eventValue: 10});
  //     }

  //     function gtag_178( url ) {
  //         return gtag_report_conversion( url );
  //     }

  //     const buttonGetQuote = document.querySelector( '#button-get-quote' );
  //     const buttonUploadBill = document.querySelector( '#button-upload-bill' );

  //     if( buttonGetQuote ) {
  //         buttonGetQuote.addEventListener( 'click', function( event ) {
  //             ga_178();
  //             gtag_178( buttonGetQuote.href );
  //         } );
  //     }

  //     if( buttonUploadBill ) {
  //         buttonUploadBill.addEventListener( 'click', function( event ) {
  //             ga_178();
  //             gtag_178( buttonUploadBill.href );
  //         } );
  //     }

  //     document.addEventListener( 'wpcf7mailsent', function( event ) {
  //         ga('send', 'event', { eventCategory: 'beat your bill', eventAction: 'submit', eventLabel: 'call me', eventValue: 10});
  //         gtag_178( 'https://www.globirdenergy.com.au/energy-saver/electricity100/' );
  //     }, false );

  // }

  // var form_187_id = $('#wpcf7-f187-p184-o1');

  // if( form_187_id ) {

  //     function ga_187() {
  //         ga('send', 'event', { eventCategory: 'beat your bill', eventAction: 'click', eventLabel: 'qoute me', eventValue: 10});
  //     }

  //     function gtag_187( url ) {
  //         return gtag_report_conversion( url );
  //     }

  //     const buttonGetQuote = document.querySelector( '#button-get-quote' );
  //     const buttonUploadBill = document.querySelector( '#button-upload-bill' );

  //     if( buttonGetQuote ) {
  //         buttonGetQuote.addEventListener( 'click', function( event ) {
  //             ga_187();
  //             gtag_187( buttonGetQuote.href );
  //         } );
  //     }

  //     if( buttonUploadBill ) {
  //         buttonUploadBill.addEventListener( 'click', function( event ) {
  //             ga_187();
  //             gtag_187( buttonUploadBill.href );
  //         } );
  //     }

  //     document.addEventListener( 'wpcf7mailsent', function( event ) {
  //         ga('send', 'event', { eventCategory: 'beat your bill', eventAction: 'submit', eventLabel: 'call me', eventValue: 10});
  //         gtag_187( 'https://www.globirdenergy.com.au/energy-saver/electricity50/' );
  //     }, false );

  // }

  var form_217_id = document.querySelector("#wpcf7-f217-p215-o1");
  if (form_217_id) {
    console.log("From form_217_id.");

    function ga_217() {
      ga("send", "event", {
        eventCategory: "beat your bill nsw",
        eventAction: "click",
        eventLabel: "qoute me",
        eventValue: 10,
      });
    }

    // function gtag_217( url ) {
    //     return gtag_report_conversion( url );
    // }

    const buttonGetQuote = document.querySelector("#button-get-quote");
    // const buttonUploadBill = document.querySelector( '#button-upload-bill' );

    if (buttonGetQuote) {
      buttonGetQuote.addEventListener("click", function (event) {
        ga_217();
        // gtag_217( buttonGetQuote.href );
      });
    }

    // if( buttonUploadBill ) {
    //     buttonUploadBill.addEventListener( 'click', function( event ) {
    //         ga_217();
    //         gtag_217( buttonUploadBill.href );
    //     } );
    // }

    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        // ga('send', 'event', { eventCategory: 'beat your bill nsw', eventAction: 'submit', eventLabel: 'call me', eventValue: 10});
        gtag("event", "submit", {
          event_category: "beat your bill nsw",
          event_label: "call me",
          value: 10,
        });
        // gtag_217( 'https://www.globirdenergy.com.au/energy-saver/electricity50-nsw/' );
      },
      false
    );
  }

  var form_234_id = document.querySelector("#wpcf7-f234-p232-o1");

  if (form_234_id) {
    console.log("From form_234_id.");
    function ga_234() {
      ga("send", "event", {
        eventCategory: "beat your bill ch nsw",
        eventAction: "click",
        eventLabel: "qoute me",
        eventValue: 10,
      });
    }

    const buttonGetQuote = document.querySelector("#button-get-quote");

    if (buttonGetQuote) {
      buttonGetQuote.addEventListener("click", function (event) {
        ga_234();
      });
    }

    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        ga("send", "event", {
          eventCategory: "beat your bill ch nsw",
          eventAction: "submit",
          eventLabel: "call me",
          eventValue: 10,
        });
      },
      false
    );
  }

  //  Quote to Win.
  var form_259_id = document.querySelector("#wpcf7-f259-p258-o1");
  if (form_259_id) {
    console.log("From form_259_id");
    function ga_259() {
      ga("send", "event", {
        eventCategory: "beat your bill ch vic",
        eventAction: "click",
        eventLabel: "qoute me",
        eventValue: 10,
      });
    }

    const buttonGetQuote = document.querySelector("#button-get-quote");

    if (buttonGetQuote) {
      buttonGetQuote.addEventListener("click", function (event) {
        ga_259();
      });
    }

    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        ga("send", "event", {
          eventCategory: "beat your bill ch vic",
          eventAction: "submit",
          eventLabel: "call me",
          eventValue: 10,
        });
      },
      false
    );
  }

  //   Win Win Page.
  var pageID286 = document.querySelector(".page-id-286");
  if (pageID286) {
    console.log("Win Win page.");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        console.log("Call me clicked.");
        gtag("event", "submit", {
          event_category: "Win Win Call Me",
          event_label: "call me",
          value: 10,
        });
        // ga('send', 'event', { eventCategory: 'Win Win Call Me', eventAction: 'submit', eventLabel: 'call me', eventValue: 10});
      },
      false
    );
  }

  // electricity50-vic/
  var pageID307 = document.querySelector(".page-id-307");
  if (pageID307) {
    console.log("electricity50-vic online.");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        console.log("Call me clicked.");
        gtag("event", "submit", {
          event_category: "beat your bill vic",
          event_label: "call me",
          value: 10,
        });
        // ga('send', 'event', { eventCategory: 'beat your bill vic', eventAction: 'submit', eventLabel: 'call me', eventValue: 10});
      },
      false
    );
  }

  //   Win Win Page - Chinese.
  var pageID313 = document.querySelector(".page-id-313");
  if (pageID313) {
    console.log("Win Win - Chinese page.");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        console.log("Call me clicked.");
        gtag("event", "submit", {
          event_category: "Win Win Call Me CH",
          event_label: "call me",
          value: 10,
        });
      },
      false
    );
  }

  // Beat your Bill page
  var pageID320 = document.querySelector(".page-id-320");
  if (pageID320) {
    console.log("Beat your Bill page.");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        console.log("Call me clicked.");
        gtag("event", "submit", {
          event_category: "beat your gas bill sa",
          event_label: "email me",
          value: 10,
        });
      },
      false
    );
  }

  var pageID349 = document.querySelector(".page-id-349");
  if (pageID349) {
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        gtag("event", "submit", {
          event_category: "beat your gas bill sa nsw",
          event_label: "email me",
          value: 10,
        });
      },
      false
    );
  }

  var pageID325 = document.querySelector(".page-id-325");
  if (pageID325) {
    console.log("page: 325");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        gtag("event", "submit", {
          event_category: "glo green",
          event_label: "email me",
          value: 10,
        });
      },
      false
    );
  }

  var pageID393 = document.querySelector(".page-id-393");
  if (pageID393) {
    console.log("page: 393");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        gtag("event", "submit", {
          event_category: "20c solar",
          event_label: "email me",
          value: 10,
        });
      },
      false
    );
  }

  // var pageID400 = document.querySelector(".page-id-400");
  // if (pageID400) {
  //   console.log("page: 400");
  //   document.addEventListener(
  //     "wpcf7mailsent",
  //     function (event) {
  //       gtag("event", "submit", {
  //         event_category: "20c solar",
  //         event_label: "email me",
  //         value: 10,
  //       });
  //     },
  //     false
  //   );
  // }

  var pageID415 = document.querySelector(".page-id-415");
  if (pageID415) {
    console.log("page: 415");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        //  gtag('event', 'submit', {
        //     'event_category': '20c solar',
        //     'event_label': 'email me',
        //     'value': 10
        //   });
      },
      false
    );
  }

  var pageID434 = document.querySelector(".page-id-434");
  if (pageID434) {
    console.log("page: 434");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        gtag("event", "submit", {
          event_category: "10c solar - vic",
          event_label: "email me",
          value: 10,
        });
      },
      false
    );
  }

  // Beat your Bill - NSW
  var pageID447 = document.querySelector(".page-id-447");
  if (pageID447) {
    console.log("Beat your Bill NSW page.");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        console.log("Call me clicked.");
        gtag("event", "submit", {
          event_category: "beat your electricity bill nsw",
          event_label: "email me",
          value: 10,
        });
      },
      false
    );
  }

  // Win/Win 2023
  var pageID465 = document.querySelector(".page-id-465");
  if (pageID465) {
    console.log("Win Win 2023 page.");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        console.log("Call me clicked.");
        gtag("event", "submit", {
          event_category: "Win Win 2023",
          event_label: "email me",
          value: 10,
        });
      },
      false
    );
  }

  // Win/Win Cow Lotto
  var pageID475 = document.querySelector(".page-id-475");
  if (pageID475) {
    console.log("Win Win Cow Lotto.");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        console.log("Email us clicked.");
        gtag("event", "submit", {
          event_category: "Win Win Cow Lotto",
          event_label: "email me",
          value: 10,
        });
      },
      false
    );
  }

  // 11c Solar - QLD
  var pageID486 = document.querySelector(".page-id-486");
  if (pageID486) {
    console.log("11c Solar - QLD");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        console.log("Email us clicked.");
        gtag("event", "submit", {
          event_category: "11c Solar - QLD",
          event_label: "email me",
          value: 10,
        });
      },
      false
    );
  }

  // 9-5Biz
  var pageID496 = document.querySelector(".page-id-496");
  if (pageID496) {
    console.log("9-5BIZ");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        console.log("Email us clicked.");
        gtag("event", "submit", {
          event_category: "9-5BIZ",
          event_label: "email me",
          value: 10,
        });
      },
      false
    );
  }

  // Beat your Bill - QLD
  var pageID507 = document.querySelector(".page-id-507");
  if (pageID507) {
    console.log("Beat your Bill - QLD");
    document.addEventListener(
      "wpcf7mailsent",
      function (event) {
        console.log("Email us clicked.");
        gtag("event", "submit", {
          event_category: "Beat your Bill - QLD",
          event_label: "email me",
          value: 10,
        });
      },
      false
    );
  }
})(jQuery);
